module.exports = __webpack_public_path__ + "img/08.54c19f1.png";